import { TrackerTranslations } from './types';

export const enTranslations: TrackerTranslations = {
    header: "Selected diseases",
    noDiseases: "No diseases chosen"
};